module.exports = __webpack_public_path__ + "images/pet.3644ff7826679d26c3fc8d39e83ee5d1.svg";